export default {
  // 搜索區
  code_sn: '二維碼',
  code_snPlaceholder: '請輸入二維碼',
  member_keyword: '用戶資訊',
  member_keywordPlaceholder: '請輸入用戶名稱或UID',
  activity_keyword: '活動資訊',
  activity_keywordPlaceholder: '請輸入活動名稱或ID',
  claimStatus: '領取狀態',
  claimStatusPlaceholder: '全部',
  claimStatusAll: '全部',
  claimStatusPendingShip: '待發貨',
  claimStatusShipped: '已發貨',
  claimStatusUnclaimed: '未領取',
  activityKeyword: '活動資訊',
  activityKeywordPlaceholder: '請輸入活動名稱、ID',
  search: '搜索',
  // 表格列
  colUserInfo: '用戶資訊',
  colQrcode: '碼號',
  colActivityInfo: '活動資訊',
  colGiftName: '禮品名稱',
  colPhone: '聯繫電話',
  colAddress: '收貨地址',
  colClaimStatus: '領取狀態',
  colAction: '操作',
  // 操作
  ship: '發貨',
  shipInfo: '發貨資訊',
  // 佔位
  dash: '——',
  none: '無',
  copySuccess: '已複製',
  copyFailed: '複製失敗',
  // 發貨彈窗
  shipTitle: '發貨',
  expressCompany: '快遞公司',
  expressCompanyPlaceholder: '請輸入快遞公司名稱',
  expressNo: '物流單號',
  expressNoPlaceholder: '請輸入物流單號',
  expressNoRequired: '請輸入物流單號',
  remark: '備註',
  remarkPlaceholder: '請輸入備註',
  ok: '確定',
  cancel: '取消',
  // 發貨資訊查看彈窗
  shipInfoTitle: '發貨資訊',
  // 空狀態
  emptyText: '暫無禮品領取記錄',
};
